import { EuiComboBox } from '@equipmentshare/ds2'
import useComboBoxState from './useComboBoxState'
import { ComboBoxOptionOption, ComboBoxProps } from './types'

export default function ComboBoxEui<T>( {
	setSelectedOption,
	selectedOption,
	data,
	getName,
	setSearchString,
	debounceDelayMs,
	async = true,
	// Dropped, not forwarded: these only exist for the MUI branch, where
	// FormRow clones the control to inject them. Under EUI the surrounding
	// EuiFormRow renders the label itself, and EuiComboBox would spread these
	// onto its wrapper div.
	// eslint-disable-next-line @typescript-eslint/no-unused-vars -- discarded from `props` on purpose
	label: _label, helperText: _helperText, error: _error, disabled: _disabled,
	...props
}: ComboBoxProps<T> ) {
	const { setInputVal, buildOption, options } = useComboBoxState( { data, getName, setSearchString, debounceDelayMs } )

	function handleSearch( search: string ) {
		setInputVal( search )
	}

	function handleSelect( option: ComboBoxOptionOption<T>[] | undefined ) {
		setSelectedOption( option?.[ 0 ] ? option[ 0 ].value : undefined )
	}

	return (
		<EuiComboBox
			placeholder="Search for or select"
			onSearchChange={setSearchString ? handleSearch : undefined}
			options={options}
			singleSelection={{ asPlainText: true }}
			selectedOptions={selectedOption ? [ buildOption( selectedOption ) ] : []}
			onChange={handleSelect}
			async={async}
			{...props}
		/>
	)
}
